module.exports = {
  // Xem--------------------------------------------------------------
  // Title----------------------------------------------
  // Tiêu đề
  'app.news.list.title.header': 'Quản lý tin tức',
  'app.news.update.title.header': 'Sửa thông tin tin tức',
  'app.news.create.title.header': 'Thêm mới tin tức',


  // Tiêu đề các cột    
  'app.news.list.title.col1': 'Tiêu đề',
  'app.news.list.title.col2': 'Tác giả',
  'app.news.list.title.col3': 'Chuyên mục',
  'app.news.list.title.col4': 'Người tạo',
  'app.news.list.title.col5': 'Ngày tạo',
  'app.news.list.title.col6': 'Trạng thái',


  // 'app.news.list.title.col6': 'Mật khẩu',
  'app.news.list.title.col7': 'Nguồn',
  'app.news.list.title.col8': 'Nhãn',
  'app.news.list.title.col9': 'Chuyên mục',
  'app.news.list.title.col10': 'Trạng thái',
  'app.news.list.title.col11': 'Mô tả ngắn gọn',
  'app.news.list.title.col12': 'Mô tả ',
  'app.news.list.title.col13': 'Từ khóa SEO',
  'app.news.list.title.col14': 'Nội dung SEO',

  // placeholder   
  'app.news.list.title.title': 'Nhập tiêu đề',
  'app.news.list.title.tag': 'Nhập nhãn',
  'app.news.list.title.source': 'Nhập nguồn',
  'app.news.list.title.author': 'Nhập tác giả',
  'app.news.list.title.categoriesId': 'Chọn chuyên mục',


};